let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iJhxv")).then(() => parcelRequire('iHGW7'));